var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input-row',{attrs:{"showElement":_vm.showElement,"label":_vm.label,"elId":_vm.elId,"status":_vm.status,"config":_vm.config,"me":_vm.me}},[_c('datetime',{attrs:{"auto":"","type":"time","input-id":_vm.elId},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }